import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface Activity {
    CityworksActivityID: number;
    Activity: string;
    Description: string;
    IsDeleted: boolean;
    selected?: boolean;
}

export interface WorkOrder {
    CityworksWorkOrderID: number;
    CityworksWOID: string;
    IsDeleted: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class ActivityService {
    private readonly cityworksActivitySubject = new BehaviorSubject<any>([]);
    public cityworksActivity$: Observable<any> = this.cityworksActivitySubject.asObservable();
    // Cityworks Work Order
    private readonly cityworksWorkOrderSubject = new Subject<boolean>();

    private readonly cityworksBaseUrl = "TimeCard/Cityworks";

    constructor(private readonly http: HttpClient) { }

    private getUrl(route: string): string {
        return `${this.cityworksBaseUrl}/${route}`;
    }

    getCityworksActivities(payload: any): Observable<Activity[]> {
        return this.http.post<Activity[]>(this.getUrl('GetCityworksActivity'), payload)
            .pipe(
                catchError(this.handleError<Activity[]>('GetCityworksActivity', []))
            );
    }

    // New method to update a single activity's status
    updateCityworksActivity(payload: any): Observable<any> {
        return this.http.post(`${this.getUrl('UpdateCityworksActivity')}`, payload)
            .pipe(
                catchError(this.handleError<Activity[]>('UpdateCityworksActivity', []))
            );
    }

    updateActivitySubject(newActivity: any): void {
        this.cityworksActivitySubject.next(newActivity);
    }

    getCityworksWorkOrders(payload: any): Observable<WorkOrder[]> {
        return this.http.post<WorkOrder[]>(this.getUrl('GetCityworksWorkOrder'), payload)
            .pipe(
                catchError(this.handleError<WorkOrder[]>('GetCityworksWorkOrder', []))
            );
    }

    // New method to save all activities and work orders at once
    saveCityworksWorkOrder(payload: any): Observable<any> {
        return this.http.post(`${this.getUrl('SaveCityworksWorkOrder')}`, payload);
    }

    setCityworksWorkOrderFlag(flag: boolean): void {
        this.cityworksWorkOrderSubject.next(flag);
    }

    getCityworksWorkOrderFlag$(): Observable<boolean> {
        return this.cityworksWorkOrderSubject.asObservable();
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            console.error(`${operation} failed: ${error.message}`);
            // Return empty result or mock data to keep the app running
            return of(result as T);
        };
    }
}